
(function() {
  function init() {
    // Find the product form area
    var productForm = document.querySelector('.product-form, .product__form, form[action*="/cart/add"]');
    if (productForm && !document.querySelector('.inquiry-btn-container')) {
      // Get product title for email subject
      var productTitle = document.querySelector('.product__title, h1')?.textContent?.trim() || 'Product';
      var mailtoLink = 'mailto:info@oriettaavec.com?subject=Wholesale%20Inquiry%20-%20' + encodeURIComponent(productTitle) + '&body=Hi%20ORIETTA%20AVEC%2C%0A%0AI%20am%20interested%20in%20ordering%20the%20following%20product%3A%0A%0AProduct%3A%20' + encodeURIComponent(productTitle) + '%0AQuantity%3A%0ASizes%20needed%3A%0APackaging%20requirements%3A%0A%0APlease%20send%20me%20wholesale%20pricing.%0A%0AThank%20you.';
      
      var container = document.createElement('div');
      container.className = 'inquiry-btn-container';
      container.innerHTML = '<a href="' + mailtoLink + '" class="inquiry-btn">Request a Quote</a>';
      productForm.parentNode.insertBefore(container, productForm.nextSibling);
    }

    // Hide price elements
    var priceElements = document.querySelectorAll('.price, [class*="price"]');
    priceElements.forEach(function(el) {
      el.style.display = 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1000);
  setTimeout(init, 2500);
})();

// about-us-heading-fix: hide auto-generated page title on About page
(function() {
  if (window.location.pathname === '/pages/about-us') {
    var h1 = document.querySelector('.section-content-wrapper h1');
    if (h1 && h1.textContent.trim() === 'About us') {
      h1.parentElement.style.display = 'none';
    }
  }
})();
